module.exports = __webpack_public_path__ + "img/donetsk_people_s_republic.b5b2986.webp";